import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEventsState, eventsAdapter, eventsKey } from './events.state';

export const selectEventsState = createFeatureSelector<IEventsState>(eventsKey);

const { selectAll, selectEntities, selectIds, selectTotal } = eventsAdapter.getSelectors(selectEventsState);

export const selectAllEvents = selectAll;
export const selectEventEntities = selectEntities;
export const selectEventIds = selectIds;
export const selectEventsTotal = selectTotal;

export const selectEventsLoading = createSelector(selectEventsState, state => state.loading);
export const selectEventsLoaded = createSelector(selectEventsState, state => state.loaded);
export const selectEventsError = createSelector(selectEventsState, state => state.error);
export const selectPrevEventsRequest = createSelector(selectEventsState, state => state.request);

export const selectEventsById = (eventId: string) =>
  createSelector(selectEventEntities, eventsMap => eventsMap[eventId]);
